import React, { useState, useCallback } from 'react';
import { useLazyQuery, DocumentNode } from '@apollo/client';
import { Menu, ActionIcon, Text } from '@mantine/core';
import { IconFilter } from '@tabler/icons-react';
import { ColumnFilterMenu } from '../ColumnFilterMenu';
import { TableHeaderWrapper } from '../TableHeaderWrapper';

interface SuggestFilterHeaderProps {
    readonly label: string;
    readonly query: DocumentNode;
    readonly optionExtractor: (data: any) => string[];
    readonly currentValue: string[] | null;
    readonly onChange: (value: string[] | null) => void;
}

export function SuggestFilterHeader({
    label,
    query,
    optionExtractor,
    currentValue,
    onChange,
}: SuggestFilterHeaderProps) {
    const [isOpen, setIsOpen] = useState(false);
    const [options, setOptions] = useState<string[]>([]);
    const [suggest, { loading }] = useLazyQuery(query);

    const handleSearch = useCallback(
        async (search: string) => {
            if (!search) {
                setOptions([]);
                return;
            }
            const { data } = await suggest({ variables: { search } });
            setOptions(optionExtractor(data));
        },
        [suggest, optionExtractor],
    );

    return (
        <TableHeaderWrapper>
            <Menu
                closeOnItemClick={false}
                shadow="md"
                width={350}
                opened={isOpen}
                onChange={setIsOpen}
                position="bottom-start"
            >
                <Menu.Target>
                    <div className="flex">
                        <Text span>{label}</Text>
                        <ActionIcon
                            variant="transparent"
                            onClick={e => {
                                e.stopPropagation();
                                setIsOpen(o => !o);
                            }}
                            className="flex-shrink-0"
                        >
                            <IconFilter
                                size={16}
                                color={
                                    currentValue && currentValue.length > 0
                                        ? '#00539f'
                                        : 'gray'
                                }
                            />
                        </ActionIcon>
                    </div>
                </Menu.Target>
                <Menu.Dropdown>
                    <ColumnFilterMenu
                        filterOptions={[]}
                        currentValue={currentValue}
                        onChange={onChange}
                        setIsOpen={setIsOpen}
                        onSearch={handleSearch}
                        options={options}
                        loading={loading}
                    />
                </Menu.Dropdown>
            </Menu>
        </TableHeaderWrapper>
    );
}
